import { Component, Input, signal, ViewChild } from '@angular/core';
import {
  ControlValueAccessor,
  FormControlDirective,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  UntypedFormGroup,
} from '@angular/forms';
import { IFormInput } from '@mwe/models';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import ShortUniqueId from 'short-unique-id';

@Component({
  selector: 'mwe-radio-input',
  templateUrl: './radio-input.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: RadioInputComponent,
      multi: true,
    },
  ],
  imports: [NgClass, FormsModule, ReactiveFormsModule, TranslatePipe],
})
export class RadioInputComponent implements ControlValueAccessor {
  @Input() parentForm: UntypedFormGroup;
  @Input() inputElem: IFormInput;
  @Input() isLoading = false;

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  uuid = signal<string>(new ShortUniqueId({ dictionary: 'alpha' }).rnd(8));

  getUniqueId(i: number): string {
    return `radio-button-option-${this.inputElem.name}-${i}`;
  }

  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }
}
